import { findOptionAndTypeFromSkuV2 } from 'commons/productUtils';
import {
  FABRIC_PRODUCT_OPTION_ID,
  LEATHER_PRODUCT_OPTION_ID,
  WOOD_PRODUCT_OPTION_ID,
} from 'commons/constants';

export function getFabricOptionValueByPartSku({
  showVariation,
  options,
  primaryOptionTypeId,
}) {
  if (!options?.length || !showVariation) {
    return;
  }
  let finalVariation = showVariation;
  // For part skus
  if (!finalVariation.startsWith('-')) {
    finalVariation = `-${finalVariation}`;
  }
  const partSkus = finalVariation.split('-').filter(v => !!v);
  let upholsteryOptionValue = null;
  partSkus.forEach(partSku => {
    const [finalOptionValue, optionTypeId] = findOptionAndTypeFromSkuV2({
      options,
      partSku,
    });
    if (
      [
        FABRIC_PRODUCT_OPTION_ID,
        LEATHER_PRODUCT_OPTION_ID,
        WOOD_PRODUCT_OPTION_ID,
      ].includes(primaryOptionTypeId) &&
      optionTypeId === primaryOptionTypeId
    ) {
      upholsteryOptionValue = finalOptionValue;
    }
    return upholsteryOptionValue;
  });
}

export function fabricFallbackURL(imageName) {
  return `https://joybird2.imgix.net/option_images/swatches/${imageName}`;
}
